import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'n11Amount'
})
export class N11AmountPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const currency_symbol = '₺';
    const formattedOutput = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2,
    });

    return formattedOutput.format(value).replace(currency_symbol, '');
  }
}
